import { groupBy } from 'lodash';
import createCachedSelector from 're-reselect';
import { createSelector } from 'reselect';

import { selectAll as selectAllEventQuotas } from 'features/scheduleBuilder/slices/eventQuotas/slice';
import { selectAll as selectAllEvents } from 'features/scheduleBuilder/slices/events/slice';
import { selectPropertiesAttribute } from 'features/scheduleBuilder/slices/properties/slice';

import { momentDate } from 'util/dateTime';

import { selectDatesInCurrentRange } from './index';

export const selectEventQuota = createCachedSelector(
  selectAllEventQuotas,
  (_, props) => momentDate(props.date).year(),
  (_, props) => momentDate(props.date).month() + 1,
  (eventQuotas, year, month) =>
    eventQuotas?.find(
      eventQuota => eventQuota.month === month && eventQuota.year === year
    ) || {}
)((_, props) => `selectEventQuota-${props.date}`);

export const selectEventsCountOnDateRange = createSelector(
  selectAllEvents,
  state => selectDatesInCurrentRange(state),
  (events, datesInCurrentRange) => {
    const eventsInRange = events.filter(event =>
      datesInCurrentRange.includes(event.date)
    );
    return eventsInRange.length;
  }
);

export const selectEventIdsOnDate = createCachedSelector(
  selectAllEvents,
  (_, date) => date,
  (events, date) => {
    const eventsByDate = groupBy(events, e => e.date) || {};
    return (eventsByDate[date] || []).map(event => event.id);
  }
)((_, date) => `selectEventIdsOnDate-${date}`);

export const selectEventsForDay = createCachedSelector(
  state => selectPropertiesAttribute({ state, attribute: 'isEventsVisible' }),
  (state, props) =>
    selectAllEvents(state).filter(event => event.date === props.date),
  (isEventsVisible, events) => (isEventsVisible ? events : [])
)((_, { date }) => `selectEventsForDay-${date}`);

export const selectEventIdsForDay = createCachedSelector(
  (state, props) =>
    selectEventsForDay(state, props)
      .map(event => event.id)
      .join(','),
  ids => (ids.length ? ids.split(',') : [])
)((_, { date }) => `selectEventIdsForDay-${date}`);
